import React from 'react';

// Interface for CommonButton props
interface CommonButtonProps {
    label: string;
    onClick?: () => void;
    type?: 'primary' | 'secondary' | 'danger';
    disabled?: boolean;
    className?: string;
}

// Common Button Component
const CommonButton: React.FC<CommonButtonProps> = ({
    label,
    onClick,
    type = 'primary',
    disabled = false,
    className = '',
}) => {
    const baseStyles = 'px-4 py-2 rounded-md font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 transition-colors';
    const typeStyles: Record<string, string> = {
        primary: 'bg-blue-600 text-white hover:bg-blue-700 focus:ring-blue-500',
        secondary: 'bg-gray-200 text-gray-800 hover:bg-gray-300 focus:ring-gray-500',
        danger: 'bg-red-600 text-white hover:bg-red-700 focus:ring-red-500',
    };

    return (
        <button
            onClick={onClick}
            disabled={disabled}
            className={`${baseStyles} ${typeStyles[type]} ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${className}`}
        >
            {label}
        </button>
    );
};

export default CommonButton;